import { compressImage } from "./compressImage.function";
import { getBase64 } from "./getBase64.function";

export const imageSelectedHandler = async (item) => {
  const compressedImage = await compressImage(item.image);
  try {
    const base64String = await getBase64(compressedImage);
    return {
      image: base64String,
      name: item.name,
    };
  } catch (error) {
    console.log(error);
  }
};
